import {isEmpty} from './tools';

/**
 * `failed` - the user can try again, `lockout` - biometry is blocked by the system
 */
export type BiometryFailure = 'failed' | 'lockout';

/**
 * global variables hiding behind singleton pattern
 */
class biometryHelperClass {
    /**
     * Opens/Closes loading indicator modal in LoginPage
     */
    loaderLoginBiometry?: (arg: boolean) => void;

    /**
     * I have no idea why this exists
     */
    runAuth: boolean;

    /**
     * Opens LoginBiometryStatusModal in BiometryScreen
     */
    actBiometryModalLogin?: () => void;

    /**
     * Opens LoginBiometryStatusModal in PasswordForm
     */
    actBiometryModalSettings?: () => void;

    /**
     * Notifies the current biometry screen that the ceremony failed
     */
    onBiometryFailed?: (reason: BiometryFailure) => void;

    /**
     * Notifies the current biometry screen that the cached biometry status was refreshed
     */
    onBiometryStatus?: () => void;
    static _instance = {} as biometryHelperClass;

    constructor() {
        this.runAuth = true;
        this.loaderLoginBiometry = undefined;
        this.actBiometryModalLogin = undefined;
        this.actBiometryModalSettings = undefined;
        this.onBiometryFailed = undefined;
        this.onBiometryStatus = undefined;
    }

    setRunAuth(runAuth: boolean) {
        this.runAuth = runAuth;
    }

    get runAuthValue() {
        return this.runAuth;
    }

    /**
     * Returns a disposer; call it on unmount, otherwise the callback of an unmounted
     * screen keeps being called from `gonative_secret_callback`
     */
    setActBiometryModalLogin(callback: () => void) {
        if (callback) {
            this.actBiometryModalLogin = callback;
        }
        return () => {
            if (this.actBiometryModalLogin === callback) {
                this.actBiometryModalLogin = undefined;
            }
        };
    }

    /**
     * Toggles LoginBiometryStatusModal in BiometryScreen
     */
    runActBiometryModalLogin() {
        if (this.actBiometryModalLogin) {
            this.actBiometryModalLogin();
        }
    }

    /**
     * Returns a disposer; call it on unmount, otherwise the callback of an unmounted
     * screen keeps being called from `gonative_secret_callback`
     */
    setActBiometryModalSettings(callback: () => void) {
        if (callback) {
            this.actBiometryModalSettings = callback;
        }
        return () => {
            if (this.actBiometryModalSettings === callback) {
                this.actBiometryModalSettings = undefined;
            }
        };
    }

    /**
     * Toggles LoginBiometryStatusModal in PasswordForm
     */
    runActBiometryModalSettings() {
        if (this.actBiometryModalSettings) {
            this.actBiometryModalSettings();
        }
    }

    setOnBiometryFailed(callback: (reason: BiometryFailure) => void) {
        if (callback) {
            this.onBiometryFailed = callback;
        }
        return () => {
            if (this.onBiometryFailed === callback) {
                this.onBiometryFailed = undefined;
            }
        };
    }

    runOnBiometryFailed(reason: BiometryFailure) {
        if (this.onBiometryFailed) {
            this.onBiometryFailed(reason);
        }
    }

    setOnBiometryStatus(callback: () => void) {
        if (callback) {
            this.onBiometryStatus = callback;
        }
        return () => {
            if (this.onBiometryStatus === callback) {
                this.onBiometryStatus = undefined;
            }
        };
    }

    runOnBiometryStatus() {
        if (this.onBiometryStatus) {
            this.onBiometryStatus();
        }
    }

    setLoaderLoginBiometry(callback: (visible: boolean) => void) {
        if (callback) {
            this.loaderLoginBiometry = callback;
        }
    }

    /**
     * Opens/Closes loading indicator modal in LoginPage
     */
    runLoaderLoginBiometry(visible: boolean) {
        if (this.loaderLoginBiometry) {
            this.loaderLoginBiometry(visible);
        }
    }
}

export function getBiometryHelper(): biometryHelperClass {
    if (!biometryHelperClass._instance || isEmpty(biometryHelperClass._instance)) {
        biometryHelperClass._instance = new biometryHelperClass();
    }
    return biometryHelperClass._instance;
}
